import React from 'react';
import {
  DataTable,
  IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import { User } from '../../../../../store/users/types';
import { useTranslation } from 'react-i18next';
import style from './UserManagementAddDataTable.module.scss';

type RowType = {
  row: {
    original: User
  }
};

interface IUserManagementAddDataTableProps {
  users: User[];
  onDeleteUser: (user: User) => any;
}

const UserManagementAddDataTable: React.FunctionComponent<IUserManagementAddDataTableProps> = (
  {
    users,
    onDeleteUser
  }
) => {
  const { t } = useTranslation();

  const columns: any[] = [
    {
      Header: t('Username'),
      accessor: 'userName',
      maxWidth: 2,
    },
    {
      Header: t('Email'),
      accessor: 'userEmail',
    },
    {
      Header: t('Is_SKF'),
      accessor: 'SKF',
      Cell: ({ row }: RowType) => {
        const { original: user } = row;
        return user.isSKF ? t('Yes') : '';
      },
    },
    {
      Header: t('Global_Id'),
      accessor: 'globalId'
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnActions,
      Cell: ({ row }: RowType) => {
        const { original: user } = row;
        return (
          <div>
            <IconTrash
              className={style.cursorPointer}
              onClick={() => onDeleteUser(user)}
            />
          </div>
        );
      },
    },
  ];
  return (
    <DataTable
      columns={columns}
      data={users}
      className={style.table}
      pagination={10}
    />
  );
};

export default UserManagementAddDataTable;
